import exampleTxt from './longnecks.txt';

import { attribute, longNeck, valueMap, TraitMap } from '../types/Types'
import { ContactlessOutlined } from '@mui/icons-material';


function manageAttributes (attributes?: attribute[]) {

    if (attributes) {
      return JSON.stringify(attributes);
    }
    else {
      return null;
    }
  }

function getRarity (attributes: attribute[], attributesMap: valueMap) {

let rarityValue = 1
let sumRarity = 0

attributes?.forEach(attribute => {
    let combined = attribute.trait_type+attribute.value;
    let percent = attributesMap.get(combined);
    if (percent) {
    // console.log('combining' + percent.toString());
    sumRarity += percent;
    // rarityValue = rarityValue*percent;
    }
});
// sumRarity = sumRarity / attributes.length;
sumRarity = sumRarity / 8;
return sumRarity;
}
  

const currentLongnecks = 2221;
  
const getText = async (setFinalLongneckArray: React.Dispatch<React.SetStateAction<longNeck[]>>,
     setTraitMapHandler?: React.Dispatch<React.SetStateAction<TraitMap>>,
     setFilterBoxMap?: React.Dispatch<React.SetStateAction<Map<string, string>>>,
     FilterBoxMap?: Map<string, string>,
     setOriginal?: React.Dispatch<React.SetStateAction<longNeck[]>>) => {
await fetch(exampleTxt)
.then(response => response.text())
.then(text => text.split('\n').map(longNeckString => {
    if (longNeckString.length > 5) {
    // console.log(longNeckString);
    return JSON.parse(longNeckString);
    }
}))
.then((longneckjsonarray: longNeck[]) => {
    let longneckstotal = longneckjsonarray.length;
    let attributesMap: valueMap = new Map<string, number>();

    let TraitMap: TraitMap = new Map<string, string[]>();

    longneckjsonarray = longneckjsonarray.slice(0, currentLongnecks);


    longneckjsonarray?.forEach((longNeck, index) => {
        longNeck?.attributes?.forEach(attribute => {
            let uniqueAttributeKey = attribute.trait_type+attribute.value;

            let currentVal = attributesMap.get(uniqueAttributeKey);

            if (currentVal) {
            attributesMap.set(uniqueAttributeKey, currentVal + 1)

            } else {
            attributesMap.set(uniqueAttributeKey, 1);
            }

            // Create Trait Type Value Map
            
            let TraitKey = TraitMap.get(attribute.trait_type);

            if (TraitKey) {
                if (!TraitKey.includes(attribute.value)) {
                    TraitKey.push(attribute.value);
                }
    
            } else {
                TraitMap.set(attribute.trait_type, [attribute.value]);
                // console.log(TraitMap);
            }

            
        });
    })

    // const InitFilterBoxMap: Map<string, string> = new Map<string, string>();

    // set trait map
    setTraitMapHandler && setTraitMapHandler(TraitMap);
    // for (let trait of TraitMap.keys()) {
    //     // console.log(trait);
    //     InitFilterBoxMap.set(trait, "");
    // }

    // setFilterBoxMap && setFilterBoxMap(InitFilterBoxMap)

    console.log(FilterBoxMap);


    attributesMap.forEach((value, key, map) => {
    attributesMap.set(key, value / longneckjsonarray.length)
    })

    let newLongnecks: longNeck[] = [];

    longneckjsonarray.forEach(longNeck => {
    if (longNeck) {
        // console.log('hi');
        let longNeckRarity = getRarity(longNeck?.attributes, attributesMap);
        let id = longNeck.id;
        let name = longNeck.name;
        let image = longNeck.image;
        let attributes = longNeck.attributes;
        let rarity = longNeckRarity;
        newLongnecks.push({id, name, image, attributes, rarity})
        // longNeck
        // let newLongneck: longNeck = {longNeck.id, longNeck.name, longNeck.image, longNeck.attributes, longNeckRarity};
        // newLongnecks.push({...longNeck, longNeckRarity})
    }
    })
    // newLongnecks.sort((a, b) => {
    //   return a.rarity - b.rarity
    // })

    // newLongnecks = newLongnecks.slice(366, 600);
    // newLongnecks = newLongnecks.slice(1150, 1250);
    // newLongnecks = newLongnecks.slice(1150, 3000);

    //       newLongnecks.sort((a, b) => {
    //   return a.rarity - b.rarity
    // })

    setFinalLongneckArray(newLongnecks);
    setOriginal && setOriginal(newLongnecks);
})
}

  export default getText;